import { render } from "./ERPPlan.vue?vue&type=template&id=17d13acf&scoped=true"
import script from "./ERPPlan.vue?vue&type=script&lang=js"
export * from "./ERPPlan.vue?vue&type=script&lang=js"

import "./ERPPlan.vue?vue&type=style&index=0&id=17d13acf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d13acf"]])

export default __exports__